import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableSkeleton = () => {
  return (
    <div>
      <div>
        <Skeleton height={"70px"} />
      </div>
      <div>
        <Skeleton count={5} height="40px" />
      </div>
    </div>
  );
};

export default TableSkeleton;
